import React from 'react';
import { cn } from '../../lib/utils';

const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'relative rounded-2xl border border-border bg-surface shadow-card overflow-hidden',
      'bg-card-sheen',
      className
    )}
    {...props}
  />
));
Card.displayName = 'Card';

export { Card };
